
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "sendScreenSizeToParent", () => $fd046e7a82b9f872$export$ba2f04ca7a83e82b);
$parcel$export(module.exports, "sendScreenSizeToChild", () => $fd046e7a82b9f872$export$2eb24a5e65ebae09);
$parcel$export(module.exports, "openUrl", () => $fd046e7a82b9f872$export$a238cfe4a10e6279);
$parcel$export(module.exports, "subscribeToScreenSizeChanges", () => $fd046e7a82b9f872$export$7a6f8e30446a0525);
$parcel$export(module.exports, "subscribeToUrlChanges", () => $fd046e7a82b9f872$export$e6dbec0beb424f66);
$parcel$export(module.exports, "subscribeToChildLoadChanges", () => $fd046e7a82b9f872$export$90ee02322f8d3109);
$parcel$export(module.exports, "initContract", () => $edf9fc62903e97ea$export$32789f8ce7a59bb6);
// Copyright © 2021 LexisNexis Risk Solutions Group
// Copyright © 2021 LexisNexis Risk Solutions Group
// eslint-disable-next-line no-shadow
var $edf9fc62903e97ea$export$426db7a6155b7a80;
(function(TYPES) {
    TYPES["IFRAME_OPEN_URL"] = "IFRAME_OPEN_URL";
    TYPES["IFRAME_SCREEN_SIZE"] = "IFRAME_SCREEN_SIZE";
    TYPES["IFRAME_SCREEN_LOADED"] = "IFRAME_SCREEN_LOADED";
})($edf9fc62903e97ea$export$426db7a6155b7a80 || ($edf9fc62903e97ea$export$426db7a6155b7a80 = {}));
function $edf9fc62903e97ea$export$abd67cc48e99962b(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
function $edf9fc62903e97ea$export$5a63da0b208cacd() {
    var url = document.referrer;
    if (document.location.ancestorOrigins) url = url || document.location.ancestorOrigins[0];
    return url;
}
function $edf9fc62903e97ea$var$CoreData() {
    var contractUrl;
    var hasChildScreenLoaded = false;
    function setContractUrl(url) {
        contractUrl = url;
    }
    function getContractUrl() {
        return contractUrl;
    }
    function setHasChildScreenLoaded(hasLoaded) {
        hasChildScreenLoaded = hasLoaded;
    }
    function getHasChildScreenLoaded() {
        return hasChildScreenLoaded;
    }
    return {
        setContractUrl: setContractUrl,
        getContractUrl: getContractUrl,
        setHasChildScreenLoaded: setHasChildScreenLoaded,
        getHasChildScreenLoaded: getHasChildScreenLoaded
    };
}
function $edf9fc62903e97ea$var$CoreFunctionality() {
    var _a = $edf9fc62903e97ea$var$CoreData(), getContractUrl = _a.getContractUrl, setHasChildScreenLoaded = _a.setHasChildScreenLoaded, setContractUrl = _a.setContractUrl, getHasChildScreenLoaded = _a.getHasChildScreenLoaded;
    function sendMessage(messageToSend, iframeToSend) {
        var sendTo = window.parent;
        if (iframeToSend) sendTo = iframeToSend.contentWindow;
        sendTo.postMessage(JSON.stringify(messageToSend), getContractUrl());
    }
    function initContract(childUrl) {
        setContractUrl(childUrl || $edf9fc62903e97ea$export$5a63da0b208cacd());
        if (!childUrl && !getHasChildScreenLoaded()) sendMessage({
            type: $edf9fc62903e97ea$export$426db7a6155b7a80.IFRAME_SCREEN_LOADED,
            data: "loaded_success"
        });
        // we are setting the load of child also in the parent to not trigger the load state message
        setHasChildScreenLoaded(true);
    }
    function receiveMessageSystem(receiveType, cb) {
        function onMessageReceive(event) {
            var domain = new URL(getContractUrl());
            if (event.origin === domain.origin && $edf9fc62903e97ea$export$abd67cc48e99962b(event.data)) {
                var _a = JSON.parse(event.data), type = _a.type, messageData = _a.data;
                if ($edf9fc62903e97ea$export$426db7a6155b7a80[type] && receiveType === type) cb(messageData);
            }
        }
        window.addEventListener("message", onMessageReceive);
        return function() {
            window.removeEventListener("message", onMessageReceive);
        };
    }
    return {
        sendMessage: sendMessage,
        initContract: initContract,
        receiveMessageSystem: receiveMessageSystem
    };
}
var $edf9fc62903e97ea$var$_a = $edf9fc62903e97ea$var$CoreFunctionality(), $edf9fc62903e97ea$export$465cb47180de50f0 = $edf9fc62903e97ea$var$_a.sendMessage, $edf9fc62903e97ea$export$32789f8ce7a59bb6 = $edf9fc62903e97ea$var$_a.initContract, $edf9fc62903e97ea$export$c250049893ef3e3c = $edf9fc62903e97ea$var$_a.receiveMessageSystem;


function $fd046e7a82b9f872$export$ba2f04ca7a83e82b(screen) {
    (0, $edf9fc62903e97ea$export$465cb47180de50f0)({
        type: (0, $edf9fc62903e97ea$export$426db7a6155b7a80).IFRAME_SCREEN_SIZE,
        data: screen
    });
}
function $fd046e7a82b9f872$export$2eb24a5e65ebae09(screen, childElement) {
    (0, $edf9fc62903e97ea$export$465cb47180de50f0)({
        type: (0, $edf9fc62903e97ea$export$426db7a6155b7a80).IFRAME_SCREEN_SIZE,
        data: screen
    }, childElement);
}
function $fd046e7a82b9f872$export$a238cfe4a10e6279(url) {
    (0, $edf9fc62903e97ea$export$465cb47180de50f0)({
        type: (0, $edf9fc62903e97ea$export$426db7a6155b7a80).IFRAME_OPEN_URL,
        data: {
            url: url
        }
    });
}
function $fd046e7a82b9f872$export$7a6f8e30446a0525(cb) {
    return (0, $edf9fc62903e97ea$export$c250049893ef3e3c)((0, $edf9fc62903e97ea$export$426db7a6155b7a80).IFRAME_SCREEN_SIZE, cb);
}
function $fd046e7a82b9f872$export$e6dbec0beb424f66(cb) {
    return (0, $edf9fc62903e97ea$export$c250049893ef3e3c)((0, $edf9fc62903e97ea$export$426db7a6155b7a80).IFRAME_OPEN_URL, cb);
}
function $fd046e7a82b9f872$export$90ee02322f8d3109(cb) {
    return (0, $edf9fc62903e97ea$export$c250049893ef3e3c)((0, $edf9fc62903e97ea$export$426db7a6155b7a80).IFRAME_SCREEN_LOADED, cb);
}


//# sourceMappingURL=main.js.map
